import React from 'react';
import Sym from './Sym';

/**
 * Estado vacío consistente para todo el sistema.
 *
 * @param {string} icon    Material Symbol
 * @param {string} title   mensaje principal
 * @param {string} text    explicación
 * @param {node}   action  botón opcional (crear el primero…)
 * @param {'sm'|'lg'} size lg = estado vacío "de página" (cupones sin cupones)
 */
const EmptyState = ({
  icon = 'inbox', title, text, action, size = 'sm', className = '', style, ...rest
}) => (
  <div
    className={['a2-empty', className].filter(Boolean).join(' ')}
    style={{
      ...(size === 'lg' ? { padding: 'clamp(48px,8vw,88px) 24px', borderRadius: 20 } : null),
      ...style,
    }}
    {...rest}
  >
    {size === 'lg' ? (
      <span
        style={{
          width: 88, height: 88, borderRadius: 24, background: 'var(--brand-soft)',
          border: '1px solid var(--brand-line)', color: 'var(--brand-2)',
          display: 'grid', placeItems: 'center', margin: '0 auto 22px',
        }}
      >
        <Sym name={icon} size={44} />
      </span>
    ) : (
      <Sym name={icon} size={44} className="a2-empty-icon" />
    )}
    {title ? (
      <p
        className="a2-empty-title"
        style={size === 'lg'
          ? { fontFamily: "'Source Serif 4', Georgia, serif", fontSize: '1.5rem', margin: '0 0 8px' }
          : undefined}
      >
        {title}
      </p>
    ) : null}
    {text ? (
      <p
        className="a2-empty-text"
        style={size === 'lg' ? { maxWidth: 400, margin: '0 auto', fontSize: '1.02rem', lineHeight: 1.5 } : undefined}
      >
        {text}
      </p>
    ) : null}
    {action ? <div style={{ marginTop: size === 'lg' ? 24 : 18 }}>{action}</div> : null}
  </div>
);

export default EmptyState;
